import { render } from "./SleepHeader.vue?vue&type=template&id=5c254524"
import script from "./SleepHeader.vue?vue&type=script&lang=js"
export * from "./SleepHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__